import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'main-assessment-score-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './assessment-score-card.component.html',
  styleUrl: './assessment-score-card.component.css'
})
export class AssessmentScoreCardComponent {

  @Input() score: number = 0;
  @Input() progress: number = 0;
  @Input() isPositive: boolean = false;
  @Input() date: string = '';

  get strokeDashArray(): string {
    const radius = 42;
    const circumference = Math.PI * radius; // Half circle
    const currentProgress = (this.score / 100) * circumference;
    return `${currentProgress} ${circumference}`;
  }

  get scoreLabel(): string {
    if (this.score >= 70) return 'Good';
    if (this.score >= 40) return 'Fair';
    return 'Needs Work';
  }

  get scoreBadgeClass(): string {
    if (this.score >= 70) return 'bg-green-100 text-green-600';
    if (this.score >= 40) return 'bg-yellow-100 text-yellow-600';
    return 'bg-red-100 text-red-600';
  }
}
